(function () {
  // =============================================================
  // Constants – same panel sizes and pricing as product calculator
  // =============================================================

  var PANEL_WIDTH_INCHES = 20;
  var CM_PER_INCH = 2.54;
  var PREVIEW_MAX_HEIGHT_PX = 200;
  var MAX_PREVIEW_PANELS = 50;
  var FALLBACK_PREVIEW_WIDTH = 400;
  var DEBOUNCE_MS = 400;

  var PANEL_HEIGHTS = [
    { inches: 53,  cm: 134.62 },
    { inches: 96,  cm: 243.84 },
    { inches: 108, cm: 274.32 },
    { inches: 118, cm: 299.72 },
    { inches: 120, cm: 304.80 },
    { inches: 150, cm: 381.00 },
    { inches: 197, cm: 500.00 },
    { inches: 394, cm: 1000.00 }
  ];

  var PANEL_HEIGHT_INCHES = PANEL_HEIGHTS.map(function (h) { return h.inches; });

  var TYPE_LABELS = {
    traditional:     'Non Pasted',
    prePasted:       'Pre-Pasted',
    peelStick:       'Peel & Stick',
    commercialVinyl: 'Commercial Grade Vinyl'
  };

  var PANEL_HUES = [350, 280, 120, 25, 330, 260, 140, 15];

  var TYPE_APP_SYNONYMS = {
    traditional:     ['nonpasted', 'traditional'],
    prePasted:       ['prepasted'],
    peelStick:       ['peelstick', 'peelandstick'],
    commercialVinyl: ['commercialgradevinyl', 'commercialvinyl']
  };

  function normalizeOption(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function parsePanelHeightInches(label) {
    var matches = String(label || '').match(/\d+(?:\.\d+)?/g);
    if (!matches || !matches.length) return NaN;
    var nums = matches.map(Number);
    for (var i = 0; i < nums.length; i++) {
      if (PANEL_HEIGHT_INCHES.indexOf(nums[i]) >= 0) return nums[i];
    }
    return nums.length === 1 ? nums[0] : nums[1];
  }

  function parseProductData(root) {
    var el = root.querySelector('[data-wpc-payload]');
    if (!el) return null;
    var parsed;
    try { parsed = JSON.parse(el.textContent); } catch (e) { return null; }
    var options = Array.isArray(parsed.options) ? parsed.options : [];
    var variants = Array.isArray(parsed.variants) ? parsed.variants : [];
    if (!options.length || !variants.length) return null;
    var panelName = (root.dataset.panelSizeOptionName || 'Panel Size').toLowerCase();
    var appName = (root.dataset.applicationOptionName || 'Application').toLowerCase();
    var panelIndex = options.findIndex(function (n) { return String(n).toLowerCase() === panelName; });
    var appIndex = options.findIndex(function (n) { return String(n).toLowerCase() === appName; });
    if (panelIndex < 0) return null;
    return { variants: variants, panelIndex: panelIndex, appIndex: appIndex };
  }

  function findVariantPriceCents(productData, typeKey, heightInches) {
    if (!productData) return null;
    var syns = TYPE_APP_SYNONYMS[typeKey] || [];
    var match = productData.variants.find(function (v) {
      if (!v || !Array.isArray(v.options)) return false;
      if (parsePanelHeightInches(v.options[productData.panelIndex]) !== heightInches) return false;
      if (productData.appIndex < 0) return true;
      var an = normalizeOption(v.options[productData.appIndex]);
      return syns.indexOf(an) >= 0 || an === normalizeOption(typeKey);
    });
    return match && Number.isFinite(match.price) ? match.price : null;
  }

  // =============================================================
  // Init
  // =============================================================

  function initStandaloneCalculator(root) {
    if (!root) return;
    if (root.dataset.wpcInitialized === 'true') return;
    root.dataset.wpcInitialized = 'true';

    var productData = parseProductData(root);
    var priceSourceNote = root.querySelector('.wpc-standalone__price-source');

    var fallbackData = null;
    var fallbackPromise = null;
    var fallbackRetried = false;
    if (root.dataset.fallbackUrl) {
      fallbackPromise = fetch(root.dataset.fallbackUrl)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { fallbackData = data; })
        .catch(function () { fallbackData = null; });
    }
    var buyerCountry = (root.dataset.country || '').toUpperCase();
    function findFallbackPrice(typeKey, heightInches) {
      if (!fallbackData || !fallbackData.regions) return null;
      var regions = fallbackData.regions;
      var keys = Object.keys(regions);
      var regionKey = keys.find(function (k) {
        var c = regions[k].countries;
        return Array.isArray(c) && c.indexOf(buyerCountry) >= 0;
      }) || fallbackData.default_region || keys[0];
      var region = regions[regionKey];
      if (!region || !region.prices) return null;
      var table = region.prices[typeKey];
      if (!table) return null;
      var amount = table[String(heightInches)];
      return Number.isFinite(amount) ? { amount: amount, currency: region.currency || 'GBP' } : null;
    }

    var widthInput    = root.querySelector('.wpc-standalone__input-width');
    var heightInput   = root.querySelector('.wpc-standalone__input-height');
    var errorMsg      = root.querySelector('.wpc-standalone__error-msg');
    var resultsEl     = root.querySelector('.wpc-standalone__results');
    var wallContainer = root.querySelector('.wpc-standalone__wall-container');
    var widthLabel    = root.querySelector('.wpc-standalone__dim-label-width');
    var unitLabels    = root.querySelectorAll('.wpc-standalone__unit-label');
    var unitBtns      = root.querySelectorAll('.wpc-standalone__unit-btn');
    var typeBtns      = root.querySelectorAll('.wpc-standalone__type-option');
    var calcBtn       = root.querySelector('.wpc-standalone__btn-calculate');

    var out = {};
    var outputs = root.querySelectorAll('[data-out]');
    outputs.forEach(function (el) { out[el.dataset.out] = el; });

    var currentUnit = 'inches';
    var currentType = 'traditional';

    function getPreviewWidth() {
      return (wallContainer && wallContainer.clientWidth > 0)
        ? wallContainer.clientWidth
        : (root.clientWidth - 100) || FALLBACK_PREVIEW_WIDTH;
    }

    // =============================================================
    // Unit helpers
    // =============================================================

    function isCm() { return currentUnit === 'cm'; }
    function toInches(v) { return v / CM_PER_INCH; }
    function toCm(v) { return v * CM_PER_INCH; }

    function convertInputValue(input, toCmMode) {
      if (!input.value) return;
      var v = parseFloat(input.value);
      if (isNaN(v)) return;
      input.value = (toCmMode ? toCm(v) : toInches(v)).toFixed(1);
    }

    // =============================================================
    // Unit toggle
    // =============================================================

    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.dataset.unit;
        currentUnit = unit;
        var label = isCm() ? 'cm' : 'inches';

        unitBtns.forEach(function (b) {
          var isActive = b.dataset.unit === unit;
          b.classList.toggle('active', isActive);
          b.setAttribute('aria-checked', String(isActive));
        });
        unitLabels.forEach(function (el) { el.textContent = label; });

        convertInputValue(widthInput, isCm());
        convertInputValue(heightInput, isCm());
      });
    });

    // =============================================================
    // Type selector
    // =============================================================

    typeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        typeBtns.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('active');
        btn.setAttribute('aria-checked', 'true');
        currentType = btn.dataset.type;
      });
    });

    // =============================================================
    // Calculation – same logic as product-page calculator
    // =============================================================

    function findPanelHeight(wallHeightInches) {
      for (var i = 0; i < PANEL_HEIGHTS.length; i++) {
        if (wallHeightInches <= PANEL_HEIGHTS[i].inches) return PANEL_HEIGHTS[i];
      }
      return null;
    }

    function showError(msg) {
      errorMsg.textContent = msg;
      errorMsg.classList.add('visible');
    }

    function hideError() {
      errorMsg.classList.remove('visible');
    }

    function calculate() {
      hideError();

      var w = parseFloat(widthInput.value);
      var h = parseFloat(heightInput.value);
      if (!w || !h || w <= 0 || h <= 0) {
        showError('Please enter valid wall dimensions.');
        return;
      }

      var widthIn = isCm() ? toInches(w) : w;
      var heightIn = isCm() ? toInches(h) : h;

      var matchedHeight = findPanelHeight(heightIn);
      if (!matchedHeight) {
        showError('Wall height exceeds our maximum panel size (394\u2033 / 1000 cm). Please contact us for custom sizes.');
        return;
      }

      var panelCount = Math.ceil(widthIn / PANEL_WIDTH_INCHES);
      if (panelCount < 1) {
        showError('Please enter a valid wall width.');
        return;
      }

      var pricePerPanel;
      var priceCurrency = presentmentCurrency;
      var usedFallback = false;
      var variantCents = findVariantPriceCents(productData, currentType, matchedHeight.inches);
      if (variantCents != null) {
        pricePerPanel = variantCents / 100;
      } else {
        var fb = findFallbackPrice(currentType, matchedHeight.inches);
        if (fb) {
          pricePerPanel = fb.amount;
          priceCurrency = fb.currency;
          usedFallback = true;
        } else if (fallbackData === null && fallbackPromise && !fallbackRetried) {
          fallbackRetried = true;
          fallbackPromise.then(function () { calculate(); });
          return;
        }
      }
      if (!Number.isFinite(pricePerPanel)) {
        showError('Pricing unavailable for this size. Please contact us.');
        return;
      }
      var totalPrice = pricePerPanel * panelCount;

      if (priceSourceNote) priceSourceNote.classList.toggle('visible', usedFallback);

      displayResults(matchedHeight, panelCount, pricePerPanel, totalPrice, priceCurrency);
      resultsEl.classList.add('visible');
      buildPreview(widthIn, heightIn, panelCount);
      resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // =============================================================
    // Currency formatting
    // =============================================================

    var presentmentCurrency = root.dataset.currencyCode || 'GBP';
    var FALLBACK_CURRENCY = 'GBP';
    var formatterCache = {};
    function formatPrice(amount, code) {
      var currency = code || presentmentCurrency;
      if (!formatterCache[currency]) {
        try {
          formatterCache[currency] = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
        } catch (e) {
          formatterCache[currency] = new Intl.NumberFormat(undefined, { style: 'currency', currency: FALLBACK_CURRENCY });
        }
      }
      return formatterCache[currency].format(amount);
    }

    // =============================================================
    // Results display
    // =============================================================

    function displayResults(matchedHeight, panelCount, pricePerPanel, totalPrice, currencyCode) {
      out['panel-size'].textContent      = '20\u2033 x ' + matchedHeight.inches + '\u2033';
      out['panel-size-cm'].textContent   = '50.8 cm x ' + matchedHeight.cm + ' cm';
      out['quantity'].textContent         = panelCount;
      out['quantity-detail'].textContent  = PANEL_WIDTH_INCHES + '\u2033 wide each';
      out['price-per-panel'].textContent  = formatPrice(pricePerPanel, currencyCode);
      out['price-type'].textContent       = TYPE_LABELS[currentType];
      out['total-price'].textContent      = formatPrice(totalPrice, currencyCode);

      out['basket-type'].textContent       = TYPE_LABELS[currentType];
      out['basket-size'].textContent       = '20\u2033 x ' + matchedHeight.inches + '\u2033';
      out['basket-price-each'].textContent = formatPrice(pricePerPanel, currencyCode);
      out['basket-qty'].textContent        = panelCount + ' panels';
      out['basket-total'].textContent      = formatPrice(totalPrice, currencyCode);
    }

    // =============================================================
    // Visual preview – same pattern SVG approach as index.html
    // =============================================================

    function generatePatternSVG(h) {
      return '<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'120\' height=\'160\' viewBox=\'0 0 120 160\'>' +
        '<rect width=\'120\' height=\'160\' fill=\'hsl(' + h + ', 35%, 93%)\'/>' +
        '<circle cx=\'30\' cy=\'25\' r=\'6\' fill=\'hsl(' + (h+10) + ', 50%, 82%)\' opacity=\'0.7\'/>' +
        '<circle cx=\'24\' cy=\'21\' r=\'4\' fill=\'hsl(' + (h+20) + ', 45%, 85%)\' opacity=\'0.6\'/>' +
        '<circle cx=\'36\' cy=\'21\' r=\'4\' fill=\'hsl(' + (h+20) + ', 45%, 85%)\' opacity=\'0.6\'/>' +
        '<circle cx=\'24\' cy=\'29\' r=\'4\' fill=\'hsl(' + (h+15) + ', 48%, 84%)\' opacity=\'0.6\'/>' +
        '<circle cx=\'36\' cy=\'29\' r=\'4\' fill=\'hsl(' + (h+15) + ', 48%, 84%)\' opacity=\'0.6\'/>' +
        '<circle cx=\'30\' cy=\'25\' r=\'3\' fill=\'hsl(' + (h+40) + ', 55%, 78%)\' opacity=\'0.8\'/>' +
        '<line x1=\'30\' y1=\'31\' x2=\'30\' y2=\'50\' stroke=\'hsl(140, 30%, 72%)\' stroke-width=\'1.5\' opacity=\'0.5\'/>' +
        '<ellipse cx=\'26\' cy=\'42\' rx=\'4\' ry=\'2.5\' fill=\'hsl(140, 35%, 78%)\' opacity=\'0.4\' transform=\'rotate(-20,26,42)\'/>' +
        '<circle cx=\'70\' cy=\'85\' r=\'5\' fill=\'hsl(' + (h+30) + ', 50%, 84%)\' opacity=\'0.6\'/>' +
        '<circle cx=\'65\' cy=\'81\' r=\'3.5\' fill=\'hsl(' + (h+35) + ', 48%, 86%)\' opacity=\'0.5\'/>' +
        '<circle cx=\'75\' cy=\'81\' r=\'3.5\' fill=\'hsl(' + (h+35) + ', 48%, 86%)\' opacity=\'0.5\'/>' +
        '<circle cx=\'70\' cy=\'85\' r=\'2.5\' fill=\'hsl(' + (h+50) + ', 50%, 80%)\' opacity=\'0.7\'/>' +
        '<line x1=\'70\' y1=\'91\' x2=\'70\' y2=\'108\' stroke=\'hsl(140, 30%, 72%)\' stroke-width=\'1.5\' opacity=\'0.5\'/>' +
        '<circle cx=\'25\' cy=\'120\' r=\'4\' fill=\'hsl(' + (h+45) + ', 45%, 83%)\' opacity=\'0.55\'/>' +
        '<circle cx=\'25\' cy=\'120\' r=\'2\' fill=\'hsl(' + (h+55) + ', 50%, 80%)\' opacity=\'0.6\'/>' +
        '</svg>';
    }

    var svgCache = {};
    function getSvgDataUrl(hue) {
      if (svgCache[hue]) return svgCache[hue];
      var svg = generatePatternSVG(hue);
      var bytes = new TextEncoder().encode(svg);
      var binary = '';
      for (var b = 0; b < bytes.length; b++) binary += String.fromCharCode(bytes[b]);
      svgCache[hue] = 'url("data:image/svg+xml;base64,' + btoa(binary) + '")';
      return svgCache[hue];
    }

    function createPanelElement(index) {
      var panel = document.createElement('div');
      panel.className = 'wpc-standalone__wall-panel';

      var hue = PANEL_HUES[index % PANEL_HUES.length];
      panel.style.background = getSvgDataUrl(hue);
      panel.style.backgroundSize = '60px auto';

      var label = document.createElement('div');
      label.className = 'wpc-standalone__panel-label';
      label.textContent = String(index + 1);
      panel.appendChild(label);

      return panel;
    }

    function formatDualUnits(inches) {
      return inches.toFixed(1) + '\u2033 (' + toCm(inches).toFixed(1) + ' cm)';
    }


    function buildPreview(wallWidthIn, wallHeightIn, panelCount) {
      wallContainer.replaceChildren();

      if (panelCount > MAX_PREVIEW_PANELS) {
        wallContainer.style.width = '';
        wallContainer.style.height = '';
        var msg = document.createElement('p');
        msg.className = 'wpc-standalone__preview-cap';
        msg.textContent = panelCount + ' panels needed \u2014 too many to preview.';
        wallContainer.appendChild(msg);
        return;
      }

      var containerW = getPreviewWidth();
      var panelWidthPx = containerW / panelCount;
      var panelHeightPx = Math.min(panelWidthPx * (wallHeightIn / PANEL_WIDTH_INCHES), PREVIEW_MAX_HEIGHT_PX);
      wallContainer.style.width = '100%';
      wallContainer.style.height = panelHeightPx + 'px';

      var frag = document.createDocumentFragment();
      for (var i = 0; i < panelCount; i++) {
        frag.appendChild(createPanelElement(i));
      }
      wallContainer.appendChild(frag);

      widthLabel.textContent = '\u27F7 Wall Width: ' + formatDualUnits(wallWidthIn);

      var heightLabel = wallContainer.parentElement.querySelector('.wpc-standalone__dim-label-height');
      if (!heightLabel) {
        heightLabel = document.createElement('div');
        heightLabel.className = 'wpc-standalone__dim-label-height';
        wallContainer.parentElement.appendChild(heightLabel);
      }
      heightLabel.textContent = '\u27F7 Wall Height: ' + formatDualUnits(wallHeightIn);
    }

    // =============================================================
    // Event listeners
    // =============================================================

    var calculating = false;
    function guardedCalculate() {
      if (calculating) return;
      calculating = true;
      calcBtn.disabled = true;
      calculate();
      setTimeout(function () { calculating = false; calcBtn.disabled = false; }, DEBOUNCE_MS);
    }

    calcBtn.addEventListener('click', guardedCalculate);

    widthInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') guardedCalculate();
    });
    heightInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') guardedCalculate();
    });
  }

  // =============================================================
  // Bootstrap
  // =============================================================

  function initAll() {
    document.querySelectorAll('.wpc-standalone').forEach(initStandaloneCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.wpc-standalone').forEach(initStandaloneCalculator);
  });
})();
